module.exports = __webpack_public_path__ + "static/media/about_us_image.12cf91fb.png";